<template>
  <div
    class="main-layout__list main-layout__list_mxh84"
    v-if="badges.all"
  >
    <div
      class="main-layout__item main-layout__item_head main-layout__item_hover main-layout__item_p14"
    >
      <!-- <div class="w-3 t-c">#</div> -->
      <div class="w-5 main-layout__item-image">
        {{ $t("listsHeader.image") }}
      </div>
      <div class="w-10">{{ $t("listsHeader.title") }}</div>
      <div class="main-layout__item-actions">
        {{ $t("listsHeader.actions") }}
      </div>
    </div>

    <div
      v-for="item in badges.all"
      :key="item.id"
      class="main-layout__item main-layout__item_hover"
    >
      <!-- <div class="w-3 t-c">{{index + 1}}</div> -->
      <div class="w-5 main-layout__item-image">
        <img :src="item.icon" alt />
      </div>
      <div class="w-10">
        <span>{{ item.name }}</span>
      </div>

      <div class="main-layout__item-actions main-layout__item-actions_center">
        <div class="filter__action">
          <label class="custom-label" @click="toggleCheckbox($event, item)">
            <input type="checkbox" />
            <div
              class="custom-checkbox"
              :ref="`custom-checkbox-${item.id}`"
              :class="{ 'custom-checkbox_inactive': !item.is_active }"
            >
              <div class="custom-checkbox__circle"></div>
            </div>
          </label>
        </div>
        <div class="filter__action">
          <svg class="main-layout__item-icon" @click="toggleModal(item)">
            <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
          </svg>
        </div>

        <div class="filter__action">
          <svg class="main-layout__item-icon" @click="toggleDeleteModal(item)">
            <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
          </svg>
        </div>
      </div>
    </div>

    <!-- <div
      v-for="item in badges.funny"
      :key="item.id"
      class="main-layout__item main-layout__item_hover"
    >
      <div class="w-5 main-layout__item-image">
        <img :src="item.icon" alt />
      </div>
      <div class="w-10">
        <span>{{ item.name }}</span>
      </div>

      <div class="main-layout__item-actions main-layout__item-actions_center">
        <div>
          <label class="custom-label" @click="toggleCheckbox($event, item)">
            <input type="checkbox" />
            <div
              class="custom-checkbox"
              :ref="`custom-checkbox-${item.id}`"
              :class="{ 'custom-checkbox_inactive': !item.is_active }"
            >
              <div class="custom-checkbox__circle"></div>
            </div>
          </label>
        </div>
        <div>
          <svg class="main-layout__item-icon" @click="toggleModal(item)">
            <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
          </svg>
        </div>

        <div>
          <svg class="main-layout__item-icon" @click="toggleDeleteModal(item)">
            <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
          </svg>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            badges: 'badges/badges',
        }),
    },
    methods: {
        ...mapMutations({
            setState: 'badges/setState',
        }),
        ...mapActions({
            fetch: 'badges/fetch',
            toggle: 'badges/toggle',
            fetchById: 'badges/fetchById',
        }),
        async toggleCheckbox(event, { id }) {
            event.preventDefault()

            const element = this.$refs[`custom-checkbox-${id}`][0]
            element.classList.toggle('custom-checkbox_inactive')

            await this.toggle(id)
        },
        toggleDeleteModal({ id }) {
            this.setState({
                key: 'deleteModal',
                value: !this.deleteModal,
            })

            this.setState({
                key: 'deletedId',
                value: id,
            })
        },
        async toggleModal({ id }) {
            await this.fetchById(id)

            this.setState({
                key: 'showModal',
                value: !this.showModal,
            })

            this.setState({
                key: 'isUpdate',
                value: true,
            })
        },
    },
    mounted() {
        this.fetch()
    },
}
</script>

<style lang="scss" scoped>
// @import "src/assets/sass/main";
// $height: 52px;

// // FILTER ITEM START
// .filter {
//   &__body {
//     display: block;
//   }

//   &__head {
//     height: $height;
//     padding: 0 20px;

//     &:hover {
//       background-color: rgba(113, 189, 74, 0.15);
//     }
//   }

//   &__option {
//     display: flex;
//     align-items: center;
//     padding: 0 20px 0 20px;
//     height: $height;

//     &:hover {
//       background-color: rgba(113, 189, 74, 0.15);
//     }
//   }

//   &__actions {
//     display: flex;
//     align-items: center;
//   }

//   &__action {
//     margin-left: 12px;

//     svg {
//       cursor: pointer;
//     }
//   }

//   &__input {
//     border: 0.5px solid transparent;
//     border-radius: 3px;
//     font-size: 10px;
//     padding: 5px;
//     transition: border 0.2s ease-in;
//     outline: none;
//     margin-left: -4px;
//     width: 140px;
//     background-color: #fff;

//     &:hover {
//       // border: 0.5px solid #aadab6;
//       // background-color: #aadab6;
//     }

//     // &_head {
//     //     font-size: 12px;
//     //     font-weight: bold;
//     //     color: #000;

//     // }
//   }

//   &__top {
//     padding-bottom: 0;
//     height: $height;
//     padding: 0 30px 0 20px;
//     font-weight: 600;
//     color: #4d4d4d;
//     font-size: 16px;
//     font-family: "SFUIDisplay-Bold";
//     display: flex;

//     &:hover {
//       background-color: rgba(113, 189, 74, 0.15);
//     }
//   }

//   &__add {
//     position: fixed;
//     right: 25px;
//     bottom: 25px;
//     display: flex;
//     align-items: flex-end;
//   }

//   &__id {
//     width: 64px;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     font-family: "SFUIDisplay-Light";
//     font-size: 30px;
//     color: #e0e0e0;
//   }

//   &__image {
//     width: 90px;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   }

//   &__title {
//     width: 20%;
//     display: flex;
//     align-items: center;
//   }

//   &__actions {
//   }
// }
// // FILTER ITEM END

// // CUSTOM CHECKBOX START
.custom-label {
  input {
    display: none;
  }
}

.custom-checkbox {
  margin-right: 16px;
  border-radius: 8px;
  width: 30px;
  height: 16px;
  // border: 1.2px solid #0d510f;
  background-color: #dfdfdf;
  position: relative;
  cursor: pointer;

  input {
    display: none;
  }

  &__circle {
    transition: right 0.2s ease-in;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    background-color: var(--bg-color-green);
    position: absolute;
    right: 13px;
  }

  &_inactive {
    .custom-checkbox__circle {
      right: 0;
      background-color: #454545;
    }
    // justify-content: flex-end;
  }
}
// // CUSTOM CHECKBOX END

// .icon {
//   transition: transform 0.3s ease-in;
// }

// .icon:hover {
//   transform: scale(1.2);
// }
</style>
